/* A field-app page that only works with signal, such as sign-in, a redirect to
 * Microsoft's page. With no network it sends the phone on to /app, which runs
 * on the work the phone holds (`27` section 6).
 */
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useHasNetwork } from "../lib/network";

export function NeedsSignal({ children }: { children: ReactNode }) {
  return useHasNetwork() ? <>{children}</> : <Navigate to="/app" replace />;
}
